import { ToneAudioNode, Gain } from "tone";

const defaultParams = {postgain:1, isActive:true}
export class FXWrapper extends ToneAudioNode {
    #isActive = false;
    effectParams = {};

    constructor(effectConstructor, wrapperParams, fxParams) {
        const {postgain, isActive} = {...defaultParams, ...wrapperParams};
        super();
        this.effectConstructor = effectConstructor;
        this.pregain = new Gain(1);
        this.postgain = new Gain(postgain);
        this.bypassGain = new Gain(1);
        this.effectGain = new Gain(0);
        this.pregain.chain(this.bypassGain, this.postgain);
        this.effectGain.connect(this.postgain);
        this.input = this.pregain;
        this.output = this.postgain;
        this.set(fxParams);
        if (isActive) this.activate();
    }

    set(fxParams) {
        this.effectParams = {...this.effectParams, ...fxParams}
        if (this.effect) this.effect.set(fxParams);
    }

    activate(fadeTime = 0.01) {
        if (this.#isActive) return;
        this.#isActive = true;

        this.bypassGain.gain.rampTo(0, fadeTime);
        this.effectGain.gain.rampTo(1, fadeTime);
        this.effect = new this.effectConstructor(this.effectParams);
        this.pregain.chain(this.effect, this.effectGain);

        if (this.deactivationTimeout) clearTimeout(this.deactivationTimeout);
    }
    
    deactivate(fadeTime = 0.01) {
        if (!this.#isActive) return;
        this.#isActive = false;

        this.bypassGain.gain.rampTo(1, fadeTime);
        this.effectGain.gain.rampTo(0, fadeTime);

        // fer això crea un clic encara que effectGain.gain.value sigui 0
        this.deactivationTimeout = setTimeout(() => {
            this.effect.disconnect();
            this.effect.dispose();
            this.effect = null;
            this.deactivationTimeout = null;
        }, fadeTime*1000);

    }

    dispose() {
        super.dispose();
        this.effect?.dispose();
        this.pregain.dispose();
        this.postgain.dispose();
        if (this.deactivationTimeout) clearTimeout(this.deactivationTimeout);
        return this;
    }
}